import { INSIGHTS_VIEW } from './liveDataAdapter';

/** Each workbook view has independent filters; resetting one must not erase the other. */
export function resetViewFilters(params: URLSearchParams, view: string): URLSearchParams {
  const next = new URLSearchParams(params);
  const keys =
    view === INSIGHTS_VIEW
      ? ['ifrom', 'ito', 'isource', 'icampaign', 'action']
      : ['from', 'to', 'source', 'campaign', 'country', 'state'];
  keys.forEach((key) => next.delete(key));
  return next;
}
